import React from 'react';
import classNames from 'classnames';

export const PageLoader = ({
  overlay = true,
  variant = 'static',
  rounded = 'rounded-md',
  contentAlign = 'vertical',
  shadow = 'shadow-lg',
  info
}) => {

  const variantClass = classNames({
    'w-48 mx-auto': variant === 'static',
    'w-full h-full absolute inset-0 z-50': variant == 'absolute',
    'w-full h-full fixed inset-0 z-50': variant == 'fixed',
    'bg-black/40': (variant == 'absolute' || variant == 'fixed') && overlay,
  });

  const contenClass = classNames(
    rounded,
    shadow,
    ['bg-white py-3 px-8'], {
      'mx-auto my-4 inline-block relative': variant == 'static',
      'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2': variant === 'absolute' || variant == 'fixed',
      'flex': contentAlign == 'horizontal',
      'text-center': contentAlign == 'vertical',
    }
  );

  return (
    <div className={variantClass}>
      <div className={contenClass}>
        <div className={`h-7${contentAlign == 'horizontal' ? ' mr-3' : ''}`}>
          <svg className={`h-7 w-7${contentAlign == 'vertical' ? ' mx-auto' : ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <rect x="0" y="0" width="100" height="100" fill="none" />
            <circle className="stroke-brand-1" cx="50" cy="50" r="40" strokeOpacity="0.2" fill="none" strokeWidth="8" strokeLinecap="round">
              <animate id="animation1" attributeName="opacity" from="0.5" to="1" dur="1s" begin="0s;animation2.end"></animate>
              <animate id="animation2" attributeName="opacity" from="1" to="0.5" dur="1s" begin="animation1.end"></animate>
            </circle>
            <circle className="stroke-brand-1" cx="50" cy="50" r="40" fill="none" strokeWidth="8" strokeLinecap="round">
              <animate attributeName="stroke-dashoffset" dur="1.5s" repeatCount="indefinite" from="0" to="502"></animate>
              <animate attributeName="stroke-dasharray" dur="1.5" repeatCount="indefinite" values="150.6 100.4;1 250;150.6 100.4"></animate>
            </circle>
          </svg>
        </div>
        { info ? <div className="mt-1 text-sm font-semibold text-gray-600">{info}</div> : null }
      </div>
    </div>
  );
};
